export default "__VITE_ASSET__cd18432b__"